/** Fallback page-2 allocation rows when document has none yet (FE preview). */
export const GPS_DEFAULT_ASSET_ALLOCATION = [
  { label: 'Aktien', value: 72.67 },
  { label: 'Rohstoffe', value: 16.03 },
  { label: 'Renten', value: 5.94 },
  { label: 'Cash', value: 5.46 },
];

export const GPS_DEFAULT_SECTOR_ALLOCATION = [
  { label: 'Basiskonsumgüter', value: 24.49 },
  { label: 'Rohstoffe', value: 13.46 },
  { label: 'Gesundheitswesen', value: 12.54 },
  { label: 'Technologie', value: 11.48 },
  { label: 'Kommunikation', value: 10.83 },
  { label: 'Industrie', value: 7.97 },
  { label: 'Gebrauchsgüter', value: 5.05 },
  { label: 'Nicht klassifizierbar', value: 4.35 },
  { label: 'Finanzwesen', value: 3.91 },
  { label: 'Versorgung', value: 2.84 },
  { label: 'Energie', value: 1.75 },
  { label: 'Immobilien', value: 1.33 },
];

export const GPS_DEFAULT_TOP10_STOCKS = [
  { name: 'Microsoft Corp. Registered Shares DL-,00000625', percentage: '3.05' },
  { name: 'Rio Tinto PLC Registered Shares LS -,10', percentage: '2.76' },
  { name: 'Xtr.(IE)-MSCI Wrld Con.Staples Registered Shares 1C USD o.N.', percentage: '2.62' },
  { name: 'BB Biotech AG Namens-Aktien SF 0,20', percentage: '2.62' },
  { name: 'Alphabet Inc. Reg. Shs Cap.Stk Cl. A DL-,001', percentage: '2.55' },
  { name: 'SAP SE Inhaber-Aktien o.N.', percentage: '2.46' },
  { name: 'Unilever PLC Registered Shares LS-,035', percentage: '2.22' },
  { name: 'Merck KGaA Inhaber-Aktien o.N.', percentage: '2.20' },
  { name: 'Glencore PLC Registered Shares DL -,01', percentage: '2.19' },
  { name: 'Nestlé S.A. Namens-Aktien SF -,10', percentage: '2.18' },
];
